import { chartColors as C, useTheme as D, QUERIES as tt } from "@fcamna/shared-component-foundations";
const s = {
  BAR: "BAR",
  COLUMN: "COLUMN",
  SCATTER: "SCATTER",
  DONUT: "DONUT",
  HEATMAP: "HEATMAP"
}, et = (y = !1, e = "light") => y ? C[e].bad2good : C[e].categorical, ot = (y = ["blue"], e = "light") => {
  if (y.length === 0)
    return C[e].blue;
  if (y.length === 1)
    return C[e][y[0]];
  const a = [], T = {};
  return y.forEach(($) => {
    $ in T ? T[$] += 1 : T[$] = 0, a.push(C[e][$][T[$]]);
  }), a;
}, it = (y) => {
  const e = D(), a = e.components.charts.defaultFont, T = (t) => {
    var l, o, c, d, r, i, h, p, u;
    const n = {};
    if (n.chart = $((t == null ? void 0 : t.type) || "", (t == null ? void 0 : t.variant) || "", ((l = t == null ? void 0 : t.series) == null ? void 0 : l.length) || 1), n.dataLabels = G(t == null ? void 0 : t.labelFormatter, t == null ? void 0 : t.type, (t == null ? void 0 : t.variant) || "", t == null ? void 0 : t.hideLabel), n.colors = V((t == null ? void 0 : t.type) || "", t == null ? void 0 : t.isCategorical, (t == null ? void 0 : t.colorPallete) || ["blue"], (t == null ? void 0 : t.mode) || "light"), n.plotOptions = J(
      (t == null ? void 0 : t.type) || "",
      t == null ? void 0 : t.hideLabel,
      (t == null ? void 0 : t.variant) || "",
      (t == null ? void 0 : t.colorScaleRanges) || [],
      t == null ? void 0 : t.dataLabels,
      ((o = t == null ? void 0 : t.series) == null ? void 0 : o.length) || 1
    ), (c = t == null ? void 0 : t.yAxis) != null && c.labels && (n.labels = (d = t == null ? void 0 : t.yAxis) == null ? void 0 : d.labels), n.legend = Q(t == null ? void 0 : t.legend, (t == null ? void 0 : t.type) || "", (t == null ? void 0 : t.series) || []), (t == null ? void 0 : t.type) !== s.DONUT && (n.grid = q(t == null ? void 0 : t.gridType, (t == null ? void 0 : t.type) || ""), n.xaxis = Z(t == null ? void 0 : t.xAxis, t == null ? void 0 : t.type), n.yaxis = _(t == null ? void 0 : t.yAxis, t == null ? void 0 : t.type)), ((t == null ? void 0 : t.type) === s.COLUMN || (t == null ? void 0 : t.type) === s.BAR) && ((t == null ? void 0 : t.type) === s.COLUMN && (t == null ? void 0 : t.variant) === "default" && ((r = t == null ? void 0 : t.series) == null ? void 0 : r.length) > 1 ? n.stroke = {
      colors: ["transparent"],
      width: 4
    } : n.stroke = {
      colors: ["#fff"],
      width: 1
    }, ((t == null ? void 0 : t.type) === s.COLUMN && ((i = t == null ? void 0 : t.yAxis) != null && i.labelPrefix) || (h = t == null ? void 0 : t.yAxis) != null && h.labelSuffix) && (n.yaxis.labels.formatter = function(m) {
      var f, S;
      return `${((f = t == null ? void 0 : t.yAxis) == null ? void 0 : f.labelPrefix) ?? ""}${m}${((S = t == null ? void 0 : t.yAxis) == null ? void 0 : S.labelSuffix) ?? ""}`;
    })), ((t == null ? void 0 : t.type) === s.COLUMN || (t == null ? void 0 : t.type) === s.BAR) && ((t == null ? void 0 : t.type) === s.COLUMN && (t == null ? void 0 : t.variant) === "default" && ((p = t == null ? void 0 : t.series) == null ? void 0 : p.length) > 1 ? n.stroke = {
      colors: ["transparent"],
      width: 4
    } : n.stroke = {
      colors: ["#fff"],
      width: 1
    }), n.tooltip = A(t == null ? void 0 : t.hideTooltip, (t == null ? void 0 : t.type) || ""), n.fill = {
      opacity: 1
    }, t.type === s.SCATTER && !((u = t == null ? void 0 : t.xAxis) != null && u.max)) {
      let m = 0;
      t.series.forEach((f) => {
        f.data.forEach((S) => {
          S[0] > m && (m = S[0]);
        });
      }), n.xaxis.max = m + 2;
    }
    return (t == null ? void 0 : t.type) === s.DONUT && (n.labels = t.labels, n.responsive = [
      {
        breakpoint: 600,
        options: {
          legend: {
            position: "bottom"
          }
        }
      }
    ]), n;
  }, $ = (t, n, l) => {
    const o = {};
    return o.toolbar = {
      show: !1
    }, o.fontFamily = a.fontFamily, t === s.COLUMN ? (l === 1 && (o.stacked = !0), n === "stacked" && (o.stacked = !0), n === "percentage" && (o.stacked = !0, o.stackType = "100%")) : t === s.BAR && (o.stacked = !0), o;
  }, V = (t, n, l, o) => n ? et(!1, o) : ot(l, o), G = (t, n, l, o) => {
    const c = {
      enabled: !1,
      enabledOnSeries: !1,
      textAnchor: "middle",
      style: {
        fontSize: a.fontSize,
        fontFamily: a.fontFamily,
        fontWeight: a.fontWeight
      },
      offsetX: 0,
      offsetY: 0
    };
    return t && (c.formatter = t), (n === s.BAR || n === s.COLUMN) && l === "percentage" && (c.enabled = !o), n === s.HEATMAP && (c.enabled = !o, c.formatter = function(d, r) {
      let i;
      return d >= 1e6 ? i = `${(d / 1e6).toFixed(1)}M` : d >= 1e4 ? i = `${Math.floor(d / 1e3)}k` : i = d, i;
    }), c;
  }, q = (t, n) => {
    const l = {
      show: !0,
      borderColor: e.components.charts.loadGridStyles.borderColor,
      strokeDashArray: 0,
      position: "back",
      xaxis: {
        lines: {
          show: !1
        }
      },
      yaxis: {
        lines: {
          show: !1
        }
      },
      row: {
        opacity: 0.3
      },
      column: {
        opacity: 0.3
      }
    };
    return (n === s.BAR || n === s.COLUMN) && (l.xaxis.lines.show = t === "xaxis" || t === "both", l.yaxis.lines.show = t === "yaxis" || t === "both"), n === s.SCATTER && (l.xaxis.lines.show = t === "xaxis" || t === "both", l.yaxis.lines.show = t === "yaxis" || t === "both"), l;
  }, Q = (t, n, l) => {
    const o = {
      position: t && (t == null ? void 0 : t.position),
      totalText: t && ((t == null ? void 0 : t.totalText) || (t != null && t.showTotal ? "Total" : void 0)),
      title: t && (t == null ? void 0 : t.title),
      hide: t && (t == null ? void 0 : t.hide),
      indicatorShape: t && (n === s.HEATMAP ? (t == null ? void 0 : t.indicatorShape) || "strap" : (t == null ? void 0 : t.indicatorShape) || "square"),
      markerWidth: t && (t == null ? void 0 : t.markerWidth) || 12,
      markerHeight: t && (t == null ? void 0 : t.markerHeight) || 12,
      horizontalAlign: t && (t == null ? void 0 : t.horizontalAlign) || "left",
      orientation: t && (t == null ? void 0 : t.orientation) || "horizontal"
    };
    let c;
    (n === s.BAR || n === s.COLUMN || n === s.SCATTER) && o.orientation === "vertical" ? (l.length === 0 ? c = void 0 : l.length <= 3 ? c = 30 * l.length : c = 100, ["bottom", "top"].includes(o.position) || (c = void 0)) : n === s.DONUT && (l.length === 0 ? c = void 0 : c = 30 * (l.length + 1));
    const d = {
      show: !o.hide,
      height: c,
      showForSingleSeries: !o.hide,
      showForNullSeries: !o.hide,
      showForZeroSeries: !o.hide,
      position: o.position || "bottom",
      horizontalAlign: o.horizontalAlign || "left",
      orientation: o.orientation || "horizontal",
      fontSize: n === "HEATMAP" ? a.fontSize : a.legendFontSize,
      fontFamily: a.fontFamily,
      fontWeight: a.legendFontWeight,
      offsetX: 0,
      offsetY: 0,
      markers: {
        width: 12,
        height: 12,
        strokeColor: e.components.charts.loadLegendStyles.markers.strokeColor,
        radius: 0,
        offsetX: 0,
        offsetY: 0
      },
      itemMargin: {
        horizontal: (o == null ? void 0 : o.indicatorShape) === "strap" ? 0 : 5,
        vertical: ["bottom", "top"].includes(o.position) ? 24 : 0
      }
    };
    return d.formatter = function(r, i) {
      var h, p, u, m, f, S, L, R, g, k, w, z, F, M, O, W, P, E, U, H, N, B, I, Y, j, X;
      if (n === s.DONUT) {
        let b = "";
        return (i == null ? void 0 : i.seriesIndex) === ((u = (p = (h = i == null ? void 0 : i.w) == null ? void 0 : h.config) == null ? void 0 : p.series) == null ? void 0 : u.length) - 1 && ((m = o.totalText) != null && m.length) && (b += `<div class="total-label">
                    <span class="total-text">${o.totalText}</span>
                    <span class="legend-text">
                    ${(L = (S = (f = i == null ? void 0 : i.w) == null ? void 0 : f.config) == null ? void 0 : S.series) == null ? void 0 : L.reduce((x, v) => x + v, 0)}
                    </span>
                  </div>`), [
          '<div class="legend-item"><span class="legend-text">' + r + '</span><span class="legend-text">' + i.w.globals.series[i.seriesIndex] + "</span></div>",
          b
        ];
      } else if (o.orientation === "vertical" && (n === s.BAR || n === s.COLUMN)) {
        let b = "";
        return (i == null ? void 0 : i.seriesIndex) === ((k = (g = (R = i == null ? void 0 : i.w) == null ? void 0 : R.config) == null ? void 0 : g.series) == null ? void 0 : k.length) - 1 && ((w = o.totalText) != null && w.length) && (b += `
          <div class="total-label">
            <span class="total-text">${o.totalText}</span>
            <span class="legend-text">
            ${(O = (M = (F = (z = i == null ? void 0 : i.w) == null ? void 0 : z.config) == null ? void 0 : F.series[0]) == null ? void 0 : M.data) == null ? void 0 : O.reduce((x, v) => x + v, 0)}
            </span>
          </div>`), ['<div class="legend-item"><span class="legend-text">' + r + "</span></div>", b];
      } else if ((i == null ? void 0 : i.seriesIndex) === ((E = (P = (W = i == null ? void 0 : i.w) == null ? void 0 : W.config) == null ? void 0 : P.series) == null ? void 0 : E.length) - 1 && ((U = o.totalText) != null && U.length)) {
        let b = o.position === "left" || o.position === "right" ? "<br />" : "";
        return b += ((B = (N = (H = i == null ? void 0 : i.w) == null ? void 0 : H.config) == null ? void 0 : N.series) == null ? void 0 : B.length) === 1 ? `<span style="font-weight: ${e.components.charts.loadLegendStyles.total.fontWeight}">Total:
              ${(X = (j = (Y = (I = i == null ? void 0 : i.w) == null ? void 0 : I.config) == null ? void 0 : Y.series[0]) == null ? void 0 : j.data) == null ? void 0 : X.reduce((x, v) => x + v, 0)}
            </span>` : "", [r, b];
      }
      return [r];
    }, o.indicatorShape === "circle" ? d.markers.radius = 12 : o.indicatorShape === "strap" && (d.markers = {
      width: o.markerWidth,
      height: o.markerHeight,
      radius: 0
    }), [s.BAR, s.COLUMN, s.SCATTER].includes(n) && (d.itemMargin.horizontal = 12, d.itemMargin.vertical = 4, d.offsetX = -16, (o.position === "bottom" || o.position === "top") && (d.offsetX = 12, d.offsetY = 10)), d;
  }, Z = (t, n) => {
    const l = {
      min: t && (t == null ? void 0 : t.min) === 0 ? 0 : (t == null ? void 0 : t.min) || void 0,
      max: t && (t == null ? void 0 : t.max) || void 0,
      title: t && (t == null ? void 0 : t.title) || "",
      tickInterval: t && (t == null ? void 0 : t.tickInterval) || void 0,
      labels: t && (t == null ? void 0 : t.labels) || void 0
    }, o = {
      categories: (l == null ? void 0 : l.labels) || [],
      tickAmount: l == null ? void 0 : l.tickInterval,
      min: l == null ? void 0 : l.min,
      max: l == null ? void 0 : l.max,
      decimalsInFloat: 0,
      position: "bottom",
      labels: {
        show: !0,
        rotate: -45,
        rotateAlways: !1,
        hideOverlappingLabels: !0,
        showDuplicates: !1,
        trim: !1,
        minHeight: void 0,
        maxHeight: 120,
        style: {
          fontSize: a.fontSize,
          fontFamily: a.fontFamily,
          fontWeight: a.axisFontWeight,
          cssClass: "apexcharts-xaxis-label"
        },
        offsetX: 0,
        offsetY: 0,
        datetimeUTC: !0,
        datetimeFormatter: {
          year: "yyyy",
          month: "MMM 'yy",
          day: "dd MMM",
          hour: "HH:mm"
        }
      },
      axisBorder: {
        show: n !== s.HEATMAP,
        color: e.components.charts.loadXaxisStyles.axisBorder.color,
        height: 1,
        width: "100%",
        offsetX: n === s.BAR ? -1 : 0,
        offsetY: n === s.SCATTER ? -1 : 0
      },
      axisTicks: {
        show: !1
      },
      title: {
        text: l == null ? void 0 : l.title,
        offsetX: 0,
        offsetY: n === s.SCATTER ? -10 : 0,
        style: {
          fontSize: a.fontSize,
          fontFamily: a.fontFamily,
          fontWeight: a.fontWeight,
          cssClass: "apexcharts-xaxis-title"
        }
      },
      tooltip: {
        enabled: !1,
        formatter: void 0,
        offsetY: 0
      }
    };
    return n === s.SCATTER && (o.labels.formatter = function(c) {
      return parseFloat(c).toFixed(1);
    }), o;
  }, _ = (t, n) => {
    const l = {
      min: t && (t == null ? void 0 : t.min) || void 0,
      max: t && (t == null ? void 0 : t.max) || void 0,
      title: t && (t == null ? void 0 : t.title) || "",
      tickInterval: t && (t == null ? void 0 : t.tickInterval) || void 0,
      labels: t && (t == null ? void 0 : t.labels) || void 0
    }, o = {
      show: !0,
      showForNullSeries: !0,
      tickAmount: l == null ? void 0 : l.tickInterval,
      min: l == null ? void 0 : l.min,
      max: l == null ? void 0 : l.max,
      decimalsInFloat: 0,
      labels: {
        style: {
          fontSize: a.fontSize,
          fontFamily: a.fontFamily,
          fontWeight: a.axisFontWeight,
          cssClass: "apexcharts-xaxis-label"
        }
      },
      axisBorder: {
        show: n !== s.HEATMAP,
        color: e.components.charts.loadYaxisStyles.axisBorder.color,
        offsetX: 0,
        offsetY: n === s.SCATTER ? -2 : 0
      },
      axisTicks: {
        show: !1
      },
      title: {
        text: l == null ? void 0 : l.title,
        rotate: -90,
        offsetX: 0,
        offsetY: 0,
        style: {
          fontSize: a.fontSize,
          fontFamily: a.fontFamily,
          fontWeight: a.fontWeight,
          cssClass: "apexcharts-yaxis-title"
        }
      },
      tooltip: {
        enabled: !1,
        offsetX: 0
      }
    };
    return n === s.BAR && (o.title.offsetX = 10), o;
  }, J = (t, n, l, o, c, d) => {
    const r = {};
    return (t === s.BAR || t === s.COLUMN) && (r.bar = {
      horizontal: !0,
      columnWidth: "60%",
      barHeight: "70%",
      dataLabels: {
        position: "top",
        maxItems: 10,
        hideOverflowingLabels: !0,
        orientation: "vertical",
        total: {
          enabled: !n,
          formatter: void 0,
          offsetX: 0,
          offsetY: 0,
          style: {
            fontFamily: a.fontFamily
          }
        }
      }
    }, l === "percentage" && (r.bar.dataLabels.total.enabled = !1, r.bar.dataLabels.position = "center", r.bar.dataLabels.orientation = "horizontal", r.bar.columnWidth = "75%"), l === "default" && d > 1 && (r.bar.columnWidth = "80%"), t === s.COLUMN ? (r.bar.horizontal = !1, r.bar.dataLabels.total.offsetY = -10, l !== "percentage" && (r.bar.borderRadius = 4), r.bar.borderRadiusApplication = "end", r.bar.borderRadiusWhenStacked = "last") : t === s.BAR && (r.bar.dataLabels.total.offsetY = 7, r.bar.dataLabels.total.offsetX = 10, r.bar.borderRadius = 4, r.bar.borderRadiusApplication = "end", r.bar.borderRadiusWhenStacked = "last")), t === s.HEATMAP && (r.heatmap = {
      radius: 4,
      enableShades: !1,
      itemMargin: {
        horizontal: 50,
        vertical: 50
      },
      colorScale: {
        ranges: o
      }
    }), t === s.DONUT && (r.pie = {
      donut: {
        labels: {
          show: !0,
          total: {
            show: !0,
            showAlways: !(c != null && c.showHoverDataLabels) || (c == null ? void 0 : c.dataLabel) || c.dataValue,
            fontSize: e.components.charts.loadPlotOptionsStyles.donut.labels.total.fontSize,
            fontFamily: a.fontFamily,
            fontWeight: a.fontWeight,
            formatter: function(i) {
              const p = i.globals.series.reduce((m, f) => f += m);
              return c != null && c.dataValue ? c.dataValue : p;
            }
          },
          name: {
            show: !0,
            offsetY: 30,
            formatter: (i) => c != null && c.showHoverDataLabels && i !== "Total" ? i : c != null && c.dataValue ? c.dataLabel : "Total",
            fontSize: e.components.charts.loadPlotOptionsStyles.donut.labels.name.fontSize,
            fontStyle: a.fontFamily,
            fontWeight: a.fontWeight,
            color: a.color
          },
          value: {
            show: !0,
            fontSize: e.components.charts.loadPlotOptionsStyles.donut.labels.value.fontSize,
            fontFamily: a.fontFamily,
            fontWeight: a.fontWeight,
            color: a.color,
            offsetY: -10
          }
        }
      },
      expandOnClick: !1
    }), r;
  }, A = (t, n) => {
    const l = {
      enabled: !t,
      styles: {
        fontSize: a.fontSize,
        fontFamily: a.fontFamily
      },
      x: {
        show: !1
      },
      y: {
        formatter: function(o) {
          return typeof parseInt(o) == "number" && !Number.isInteger(parseInt(o)) ? o.toFixed(2) : o;
        }
      },
      custom: n === s.HEATMAP ? function({ series: o, seriesIndex: c, dataPointIndex: d, w: r }) {
        var u, m, f, S;
        const i = (m = (u = r == null ? void 0 : r.globals) == null ? void 0 : u.initialSeries[c]) == null ? void 0 : m.data[d], h = Object.keys(i), p = (S = (f = r == null ? void 0 : r.config) == null ? void 0 : f.series[c]) == null ? void 0 : S.name;
        return `
              <span
                style="padding:${e.components.charts.loadTooltipStyles.custom.default.span.padding};
                  color:${e.components.charts.loadTooltipStyles.custom.default.span.color};
                  font-family:${e.components.charts.loadTooltipStyles.custom.default.span.fontFamily};
                  font-size: ${e.components.charts.loadTooltipStyles.custom.default.span.fontSize};
                  font-style: ${e.components.charts.loadTooltipStyles.custom.default.span.fontStyle};
                  font-weight: ${e.components.charts.loadTooltipStyles.custom.default.span.fontWeight};
                  line-height:${e.components.charts.loadTooltipStyles.custom.default.span.lineHeight};"
              >${p}</span>
              <ul
                style="list-style-type: ${e.components.charts.loadTooltipStyles.custom.default.ul.listStyleType};
                  padding:${e.components.charts.loadTooltipStyles.custom.default.ul.padding};
                  color:  ${e.components.charts.loadTooltipStyles.custom.default.ul.color};
                  font-family: ${e.components.charts.loadTooltipStyles.custom.default.ul.fontFamily};
                  font-size: ${e.components.charts.loadTooltipStyles.custom.default.ul.fontSize};
                  font-style: ${e.components.charts.loadTooltipStyles.custom.default.ul.fontStyle};
                  font-weight: ${e.components.charts.loadTooltipStyles.custom.default.ul.fontWeight};
                  line-height: ${e.components.charts.loadTooltipStyles.custom.default.ul.lineHeight};"
              >
                ${h && h.map((L) => `<li>${L.charAt(0).toUpperCase() + L.slice(1)}: ${i[L]} </li>`).join("").replace(",", "")}
              </ul>`;
      } : void 0
    };
    return n === s.SCATTER && (l.custom = function({ seriesIndex: o, dataPointIndex: c, w: d }) {
      var h, p;
      const r = d.config.series[o], i = (p = (h = d == null ? void 0 : d.globals) == null ? void 0 : h.initialSeries[o]) == null ? void 0 : p.data[c];
      return `<div class="custom-tooltip" style="display:${e.components.charts.loadTooltipStyles.custom.scatter.divCustomTooltip.display}; justify-content:${e.components.charts.loadTooltipStyles.custom.scatter.divCustomTooltip.justifyContent}; align-items: ${e.components.charts.loadTooltipStyles.custom.scatter.divCustomTooltip.alignItems};
                padding: ${e.components.charts.loadTooltipStyles.custom.scatter.divCustomTooltip.padding}; ">
                <div class="series-marker" style="background-color: ${d.config.colors[o]}; height: ${e.components.charts.loadTooltipStyles.custom.scatter.divSeriesMarker.height}; width: ${e.components.charts.loadTooltipStyles.custom.scatter.divSeriesMarker.width}; border-radius: ${e.components.charts.loadTooltipStyles.custom.scatter.divSeriesMarker.borderRadius}; margin-right: ${e.components.charts.loadTooltipStyles.custom.scatter.divSeriesMarker.marginRight};">
                </div>
                <div style="padding: ${e.components.charts.loadTooltipStyles.custom.scatter.div.padding}; display: ${e.components.charts.loadTooltipStyles.custom.scatter.div.display}; justify-content: ${e.components.charts.loadTooltipStyles.custom.scatter.div.justifyContent}; align-items: ${e.components.charts.loadTooltipStyles.custom.scatter.div.alignItems};
                font-size: ${e.components.charts.loadTooltipStyles.custom.scatter.div.fontSize}; font-family: ${e.components.charts.loadTooltipStyles.custom.scatter.div.fontFamily}; color:${e.components.charts.loadTooltipStyles.custom.scatter.div.color};">
                  <div class="series-name" style="margin-right: ${e.components.charts.loadTooltipStyles.custom.scatter.div.divChildOne.marginRight};">
                    ${r.name}:
                  </div>
                  <div class="data-value" style="font-weight: ${e.components.charts.loadTooltipStyles.custom.scatter.div.divChildTwo.fontWeight};">
                    ${i[0]}, ${i[1]}
                  </div>
                </div>
              </div>`;
    }), l;
  }, K = (t) => {
    const n = `
    .apexcharts-tooltip {
      border: ${e.components.charts.customStyles.tooltipStyles.apexchartsTooltip.border} !important;
      color:${e.components.charts.customStyles.tooltipStyles.apexchartsTooltip.color};
    }
    .apexcharts-tooltip-series-group{
      padding-top: ${e.components.charts.customStyles.tooltipStyles.apexchartsTooltipSeriesGroup.paddingTop};
    }
  `, l = `
  .apexcharts-legend-series {
    display: ${e.components.charts.customStyles.legendStrapStyle.apexchartsLegendSeries.display} !important;
    flex-direction: ${e.components.charts.customStyles.legendStrapStyle.apexchartsLegendSeries.flexDirection} !important;
    gap: ${e.components.charts.customStyles.legendStrapStyle.apexchartsLegendSeries.gap} !important;
  }

  /* CSS styles for the first .apexcharts-legend-marker */
  .apexcharts-legend-series:first-of-type .apexcharts-legend-marker {
    border-top-left-radius: ${e.components.charts.customStyles.legendStrapStyle.apexchartsLegendSeriesFirstOfType.borderTopLeftRadius} !important;
    border-bottom-left-radius: ${e.components.charts.customStyles.legendStrapStyle.apexchartsLegendSeriesFirstOfType.borderBottomLeftRadius} !important;
  }
  /* CSS styles for the last .apexcharts-legend-marker */
  .apexcharts-legend-series:last-of-type .apexcharts-legend-marker {
    border-top-right-radius: ${e.components.charts.customStyles.legendStrapStyle.apexchartsLegendSeriesLastOfType.borderTopRightRadius} !important;
    border-bottom-right-radius: ${e.components.charts.customStyles.legendStrapStyle.apexchartsLegendSeriesLastOfType.borderBottomRightRadius} !important;
  }`, o = `
    .apexcharts-legend.apx-legend-position-right {
        justify-content: ${e.components.charts.customStyles.legendLeftRightPositionStyle.apexchartsLegendApxLegendPositionRight.justifyContent} !important;
        margin-top: ${e.components.charts.customStyles.legendLeftRightPositionStyle.apexchartsLegendApxLegendPositionRight.marginTop} !important;
    }

    .apexcharts-legend.apx-legend-position-left {
        justify-content: ${e.components.charts.customStyles.legendLeftRightPositionStyle.apexchartsLegendApxLegendPositionLeft.justifyContent} !important;
        margin-top: ${e.components.charts.customStyles.legendLeftRightPositionStyle.apexchartsLegendApxLegendPositionLeft.marginTop} !important;
        left: ${e.components.charts.customStyles.legendLeftRightPositionStyle.apexchartsLegendApxLegendPositionLeft.left} !important;
    }
    `, c = (...r) => {
      const [i, h, p, u] = r;
      if ([s.BAR, s.COLUMN, s.SCATTER].includes(t.type))
        return u ? `
                .apexcharts-legend {
                  flex-direction: ${h === "vertical" ? e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.flexDirection.vertical : e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.flexDirection.default};
                  max-height: ${e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.maxHeight} !important;
                  overflow: ${e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.overflow};
                  flex-wrap: ${h === "horizontal" && ["top", "bottom"].includes(p) ? `${e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.flexWrap.horizontalTopBottom} !important` : `${e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.flexWrap.default} !important`};
                  justify-content: ${(() => h === "horizontal" ? i === "right" ? e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.justifyContent.horizontal.right : i === "left" ? e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.justifyContent.horizontal.left : e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.justifyContent.horizontal.default : `${e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.justifyContent.vertical} !important`)()};
                  align-items: ${(() => {
          if (!["right", "left"].includes(p))
            return i === "right" ? e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.alignItems.horizontal.right : i === "left" ? e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.alignItems.horizontal.left : e.components.charts.customStyles.legendStyles.barColumnScatter.verical.apexchartsLegend.alignItems.horizontal.default;
        })()};
                }
            ` : `
          .apexcharts-legend .apexcharts-legend-series {
            display: ${e.components.charts.customStyles.legendStyles.barColumnScatter.default.apexchartsLegendSeries.display} !important;
            align-items: ${e.components.charts.customStyles.legendStyles.barColumnScatter.default.apexchartsLegendSeries.alignItems} !important;
            padding: ${e.components.charts.customStyles.legendStyles.barColumnScatter.default.apexchartsLegendSeries.padding};
            gap: ${e.components.charts.customStyles.legendStyles.barColumnScatter.default.apexchartsLegendSeries.gap};

            .apexcharts-legend-text{
              padding-left: ${e.components.charts.customStyles.legendStyles.barColumnScatter.default.apexchartsLegendSeries.apexchartsLegendText.paddingLeft};
              margin-left: ${e.components.charts.customStyles.legendStyles.barColumnScatter.default.apexchartsLegendSeries.apexchartsLegendText.marginLeft};
            }
          }
          .apexcharts-legend-marker {
            margin-right:${e.components.charts.customStyles.legendStyles.barColumnScatter.default.apexchartsLegendMarker.marginRight};
          }
        `;
      if (t.type === s.DONUT)
        return `
        .apx-legend-position-right,
        .apx-legend-position-left {
          top: ${e.components.charts.customStyles.legendStyles.donut.apxLegendPositionRightLeft.top} !important;
          height: ${e.components.charts.customStyles.legendStyles.donut.apxLegendPositionRightLeft.height} !important;
          padding: ${e.components.charts.customStyles.legendStyles.donut.apxLegendPositionRightLeft.padding};
          width: ${e.components.charts.customStyles.legendStyles.donut.apxLegendPositionRightLeft.width} !important;
        }
        .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
          display: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendSeries.display};
          align-items: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendSeries.alignItems};
          padding: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendSeries.padding};
          padding-left: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendSeries.paddingLeft};
        }
        .apexcharts-legend-text * {
          pointer-events:${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendTextAll.pointerEvents};
          display: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendTextAll.display} !important;
          /* gap: 10px; */
          justify-content: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendTextAll.justifyContent} !important;
          margin-left: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendTextAll.marginLeft} !important;
        }
        .apexcharts-legend-text {
          width: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendText.width} !important;
          line-height: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendText.lineHeight};
        }
        .apexcharts-legend-marker {
          top: ${e.components.charts.customStyles.legendStyles.donut.apexchartsLegendMarker.top} !important;
        }
        .total-label {
          position: ${e.components.charts.customStyles.legendStyles.donut.totalLabel.position};
          font-weight: ${e.components.charts.customStyles.legendStyles.donut.totalLabel.fontWeight};
          left: ${e.components.charts.customStyles.legendStyles.donut.totalLabel.left};
          margin: ${e.components.charts.customStyles.legendStyles.donut.totalLabel.margin} !important;
          padding-top: ${e.components.charts.customStyles.legendStyles.donut.totalLabel.paddingTop};
          width: ${e.components.charts.customStyles.legendStyles.donut.totalLabel.width};
        }
        .total-text {
          margin-left: ${e.components.charts.customStyles.legendStyles.donut.totalText.marginLeft} !important;
        }

        @media ${tt.mobile} {
          .apexcharts-legend.apexcharts-align-left .apexcharts-legend-series {
            display: ${e.components.charts.customStyles.legendStyles.donut.mobile.apexchartsLegendSeries.display};
          }
          .apexcharts-legend {
            display: ${e.components.charts.customStyles.legendStyles.donut.mobile.apexchartsLegend.display};
            width: ${e.components.charts.customStyles.legendStyles.donut.mobile.apexchartsLegend.width};
            margin: ${e.components.charts.customStyles.legendStyles.donut.mobile.apexchartsLegend.margin};
        }
        }
      `;
    }, d = `
    .apexcharts-gridlines-vertical{
      :first-child {
        display: ${e.components.charts.customStyles.gridStyles.apexchartsGridlinesVertical.firstChild.display};
      }
    }
  `;
    return {
      tooltipStyles: n,
      legendStrapStyle: l,
      legendStyles: c,
      legendLeftRightPositionStyle: o,
      gridStyles: d
    };
  };
  return {
    options: T(y),
    createOptions: T,
    customStyles: K
    // Include other functions and values here
  };
};
export {
  s as C,
  it as u
};
